module.exports = __webpack_public_path__ + "static/media/reports_wallet-statement.6f1805d4.svg";